import { parseJWT } from './jwt';

export function persistAuthSession({ access_token: accessToken, user, plan }) {
    if (!accessToken) {
        return;
    }

    localStorage.setItem('access_token', accessToken);
    const decodedToken = parseJWT(accessToken) || {};
    const planName = plan?.name ?? user?.plan_name ?? 'Free';

    const storedUser = {
        name: user?.name ?? decodedToken.name ?? '',
        email: user?.email ?? decodedToken.email ?? '',
        profile_picture: user?.profile_picture ?? decodedToken.profile_picture,
        store_name: user?.store_name ?? decodedToken.store_name,
        whatsapp: user?.whatsapp ?? decodedToken.whatsapp,
        site: user?.site ?? decodedToken.site,
        instagram: user?.instagram ?? decodedToken.instagram,
        tiktok: user?.tiktok ?? decodedToken.tiktok,
        plan_name: planName,
    };

    localStorage.setItem('user', JSON.stringify(storedUser));
}
